import {CustomModal} from "../../../../../components/UI/AntCustom/CustomModal";
import React, {Dispatch, FC, SetStateAction} from "react";
import {Col, Row} from "antd";
import styled from "styled-components";
import {CustomButton} from "../../../../../components/UI/AntCustom/CustomButton";
import {DeleteOutlined} from "@ant-design/icons";
import CloseIcon from "../../../../../media/icons/close.svg?react";
import {useAppDispatch, useAppSelector} from "../../../../../store/store";
import {archiveOrderRequest} from "../../../../../store/reducers/freighterRequestsReducer/freighterRequestsReducer";
import {defineMessages, useIntl} from "react-intl";
import {CommonButtonMessages} from "../../../../../intl/commonMessages/CommonButtonMessages";
import {amplitudeEvents} from "../../../../../utils/analytics/amplitude";

const WhiteCloseIcon = styled(CloseIcon)`
  color: white;
  fill: white;
  
  path {
    fill: white;
  }
`;

const ArchiveOrderRequestModalMessages = defineMessages({
  title: {
    id: "archiveOrderRequestModal.title",
    defaultMessage: "Respond archiving",
  },
  warn: {
    id: "archiveOrderRequestModal.warn",
    defaultMessage: "Are you sure you want to archive the respond? You won't be able to revert this action.",
  },
})

export type ItineraryLeg = { airport_from_code?: string; airport_to_code?: string };

interface IArchiveOrderRequestModal {
  orderRequestId: number;
  isModalVisible: boolean;
  setIsModalVisible: Dispatch<SetStateAction<boolean>>;
  /** Itinerary for analytics when operator declines (archives) the request. */
  itinerary?: ItineraryLeg[];
}

export const ArchiveOrderRequestModal: FC<IArchiveOrderRequestModal> = ({orderRequestId, isModalVisible, setIsModalVisible, itinerary}) => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const {
    isLoading: isArchiveLoading,
  } = useAppSelector(state => state.freighterRequests.archiveOrderRequest);

  const handleArchive = () => {
    amplitudeEvents.operatorRespondToRequest({
      action: 'decline',
      proposed_count: 0,
      declined_count: 1,
      itinerary: itinerary?.length ? itinerary : undefined,
      min_proposed_price: null,
      max_proposed_price: null,
    });
    dispatch(archiveOrderRequest({orderRequestId}));
  };

  return <CustomModal
    title={intl.formatMessage(ArchiveOrderRequestModalMessages.title)}
    open={isModalVisible}
    onCancel={() => setIsModalVisible(false)}
    centered
    footer={null}
  >
    <Row gutter={8}>
      <Col span={24}>
        <div>{intl.formatMessage(ArchiveOrderRequestModalMessages.warn)}</div>
      </Col>
    </Row>

    <Row gutter={8} style={{marginTop: 24}}>
      <Col span={12}>
        <CustomButton
          style={{width: "100%"}}
          heightSize={'m'}
          onClick={() => setIsModalVisible(false)}
        >
          {intl.formatMessage(CommonButtonMessages.cancel)}
        </CustomButton>
      </Col>

      <Col span={12}>
        <CustomButton
          style={{width: "100%"}}
          heightSize={'m'}
          type={'primary'}
          icon={<WhiteCloseIcon />}
          danger
          loading={isArchiveLoading}
          onClick={handleArchive}
        >
          {intl.formatMessage(CommonButtonMessages.archive)}
        </CustomButton>
      </Col>
    </Row>
  </CustomModal>
}
